import { useState } from 'react';
import { useRequest } from 'ahooks';
import { lx } from '@cap/rzmt-core';
import useCourseClassify, { ICourseClassify } from '@cap/share/src/hooks/useCourseClassify';
import { navigatePage, PC_PATH } from '@cap/share/src/utils/navigation/index';

import './index.less';

export default () => {
  const { getClassifyTree } = useCourseClassify({ treeDeep: 1 });
  const [classifyList, setClassifyList] = useState<ICourseClassify[]>([]);

  const handleJump = (item?: ICourseClassify) => {
    lx.moduleClick({
      bid: 'b_donation_b2lbha07_mc',
    });
    const query: Record<string, string> = {};
    if (item) {
      const { dimension, classifyPath } = item;
      query.dimension = dimension;
      query.classifyPath = classifyPath;
    }
    navigatePage(PC_PATH.CourseCenter, { query });
  };

  useRequest(getClassifyTree, {
    onSuccess: (res) => {
      setClassifyList(res);
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  return (
    <div className="left-classify">
      {classifyList.map((item) => {
        return (
          <div key={item.id} className="classify-item">
            <div className="dimension-bar" onClick={() => handleJump()}>
              <span className="dimension-name">{item.name}</span>
              <img
                className="dimension-right-icon"
                src="//img.meituan.net/mtdxweb/846f5a046757b60fe85e2d2d8af434a7426.png"
                alt=""
              />
              {/* <Icon type="right" /> */}
            </div>
            <div className="category-list">
              {item.children?.map((child) => {
                return (
                  <span key={child.id} className="category-item" onClick={() => handleJump(child)}>
                    {child.name}
                  </span>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
